import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseProperty} from '../case-property';
import {CasePropertyService} from '../case-property.service';

@Component({
  selector: 'app-case-property-edit',
  templateUrl: 'edit.component.html',
})
export class CasePropertyEditComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: CaseProperty;

  private givenCaseId: string;

  constructor(private readonly casePropertyService: CasePropertyService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string, model: CaseProperty): void {
    this.givenCaseId = caseId;
    this.model = model;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmEdit($event) {
    $event.preventDefault();
    this.disabled = true;
    this.casePropertyService
      .updateCaseProperty(this.model.id, this.model, {
        parameters: { id: this.caseId },
      })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = undefined;
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
